export enum EStatusChipType {
  icon,
  dark,
  label,
}
